/* PDP "Gravação" block: checkbox that reveals the field, character counter, symbol picker and character limit.
   Unchecked: the field is disabled (not sent, not charged). Checked: the field is required.
   Adding the engraving product to the cart lives in component-product-form.js. */
if (!customElements.get('product-engraving')) {
  customElements.define('product-engraving', class ProductEngraving extends HTMLElement {
    connectedCallback() {
      this.limit = parseInt(this.dataset.limit, 10) || 0;
      this.input = this.querySelector('[data-engraving-input]');
      this.counter = this.querySelector('[data-engraving-counter]');
      this.symbolsToggle = this.querySelector('[data-engraving-symbols-toggle]');
      this.symbolsList = this.querySelector('[data-engraving-symbols-list]');
      this.toggle = this.querySelector('[data-engraving-toggle]');
      this.body = this.querySelector('[data-engraving-body]');
      if (!this.input) return;

      this.onInput = () => this.enforceLimit();
      this.onToggleEngraving = () => this.setActive(this.toggle.checked, true);
      this.onToggle = () => this.toggleSymbols();
      this.onSymbolClick = (event) => {
        const button = event.target.closest('[data-engraving-symbol]');
        if (button) this.insertSymbol(button.dataset.engravingSymbol);
      };
      this.onDocumentClick = (event) => {
        if (this.symbolsList && !this.symbolsList.hidden && !this.contains(event.target)) this.toggleSymbols(false);
      };

      this.input.addEventListener('input', this.onInput);
      this.toggle?.addEventListener('change', this.onToggleEngraving);
      this.symbolsToggle?.addEventListener('click', this.onToggle);
      this.symbolsList?.addEventListener('click', this.onSymbolClick);
      document.addEventListener('click', this.onDocumentClick);
      this.setActive(!!this.toggle?.checked, false);
      this.enforceLimit();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.toggle?.removeEventListener('change', this.onToggleEngraving);
      this.symbolsToggle?.removeEventListener('click', this.onToggle);
      this.symbolsList?.removeEventListener('click', this.onSymbolClick);
      document.removeEventListener('click', this.onDocumentClick);
    }

    setActive(active, focus) {
      if (this.body) this.body.hidden = !active;
      this.input.disabled = !active;
      this.input.required = active;
      if (!active) {
        this.toggleSymbols(false);
        // drop the "required" error left by the product form, if any
        this.closest('product-information')?.querySelectorAll(`#${CSS.escape(this.input.id)}.required-field-error, #${CSS.escape(this.input.id)}Submit.required-field-error`).forEach((error) => error.remove());
      } else if (focus) {
        this.input.focus();
      }
    }

    // Count by code point so symbols outside the BMP still count as one character
    length(value) {
      return Array.from(value).length;
    }

    enforceLimit() {
      let chars = Array.from(this.input.value);
      if (this.limit && chars.length > this.limit) {
        chars = chars.slice(0, this.limit);
        this.input.value = chars.join('');
      }
      if (this.counter) this.counter.textContent = `${chars.length} / ${this.limit}`;
      if (this.symbolsList) {
        const full = this.limit && chars.length >= this.limit;
        this.symbolsList.querySelectorAll('[data-engraving-symbol]').forEach((button) => { button.disabled = full; });
      }
    }

    insertSymbol(symbol) {
      if (this.limit && this.length(this.input.value) >= this.limit) return;
      const start = this.input.selectionStart ?? this.input.value.length;
      const end = this.input.selectionEnd ?? this.input.value.length;
      this.input.value = this.input.value.slice(0, start) + symbol + this.input.value.slice(end);
      const caret = start + symbol.length;
      this.input.focus();
      this.input.setSelectionRange(caret, caret);
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.toggleSymbols(false);
    }

    toggleSymbols(force) {
      if (!this.symbolsList) return;
      const open = typeof force === 'boolean' ? force : this.symbolsList.hidden;
      this.symbolsList.hidden = !open;
      this.symbolsToggle?.setAttribute('aria-expanded', String(open));
    }
  });
}
